import { render, staticRenderFns } from "./King.vue?vue&type=template&id=3cafe806&"
import script from "./King.vue?vue&type=script&lang=js&"
export * from "./King.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports